import React, { useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import TwoFa from "../../elements/twoFa/TwoFa";
import DialogModal from "../../elements/dialogModal/DialogModal";
import { TextField } from "@material-ui/core";
import DefaultButton from "../../styles/materialButtonStyle";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import { useTranslation } from "react-i18next";

import { StyledBlockAction, StyledInputBlock } from "../../styles/styledTabsForm";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const RatesEditForm = ({ rate, setRate, notification, setNotification, url }) => {
  const { t } = useTranslation("ratesPage");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [submitData, setSubmitData] = useState({
    selling: null,
    purchase: null
  });

  const inputProps = {
    step: "any"
  };

  const handleSave = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.put(url + rate.id, submitData, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setOpen(false);
        setRate(response.data);
        setNotification({ ...notification, visible: true, type: "success", message: t("rates.details.changeForm.success") });
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("rates.details.changeForm.twoFa")}
        content={<TwoFa
          handleSubmit={handleSave}
          error={error}
        />}
      />
      <StyledInputBlock
        as="form"
        onSubmit={event => {
          event.preventDefault();
          setSubmitData({
            ...setSubmitData,
            selling: event.target.selling.value,
            purchase: event.target.purchase.value
          });
          setOpen(true);
        }}
      >
        <TextField
          className="grid-form__input"
          variant="filled"
          label={t("rates.details.changeForm.selling")}
          id="selling"
          type="number"
          inputProps={inputProps}
          name="selling"
          defaultValue={rate.cleanSelling}
        />
        <TextField
          className="grid-form__input"
          variant="filled"
          label={t("rates.details.changeForm.purchase")}
          id="purchase"
          type="number"
          inputProps={inputProps}
          name="purchase"
          defaultValue={rate.cleanPurchase}
        />
        <StyledBlockAction>
          <DefaultButton
            color="success"
            type="submit"
          >
            {t("rates.details.changeForm.save")}
          </DefaultButton>
        </StyledBlockAction>
      </StyledInputBlock>
    </>
  );
};

export default RatesEditForm;